import axios from "axios";

export const sendMessage = async (payload) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/messages/message`, payload);
    // console.log("request result", result);
    return result.data;
};

export const firstMessage = async (payload) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/firstMsgs/firstMsg`, payload);
    // console.log("request result", result);
    return result.data;
};

export const firstMessageList = async (payload) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/firstMsgs/list`, payload);
    // console.log("request result", result);
    return result.data;
};

export const showfirstMessage = async (payload) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/firstMsgs/showFirstMsg`, payload);
    // console.log("request result", result);
    return result.data;
};

export const showMessage = async (payload) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/messages/showMsg`, payload);
    // console.log("request result", result);
    return result.data;
};

export const retrievePhoto = async (payload) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/firstMsgs/retrievePhoto`, payload);
    // console.log("request result", result);
    return result.data;
};

export const showAllList = async (payload) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/firstMsgs/allList`);
    // console.log("request result", result);
    return result.data;
};

export const showLastMsg = async (payload) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/messages/showLastMsg`, payload);
    // console.log("request result", result);
    return result.data;
};

